<div *ngIf="answer && supplierAnswsers" class="full-width">
    <div class="row">
        <div class="col-10 text-left">
            <span *ngIf="sharedDatasSvc.debug">dependencyOffsetLevel = {{supplierAnswsers.dependencyOffsetLevel(rseQuestion)}}</span>
            <label class="control-label mx-2" [paflabel]="rseQuestion.LblCod"></label>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-start">
            <input type="radio" #unchecked [name]="answerOptionName" [value]="0" [(ngModel)]="answer.Answer" required kendoRadioButton [disabled]="readonly" (ngModelChange)="onValueChanged($event)" />
            <label class="ml-1" paflabel="Non"></label>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-start">
            <input type="radio" #checked [name]="answerOptionName" [value]="1" [(ngModel)]="answer.Answer" required kendoRadioButton [disabled]="readonly" (ngModelChange)="onValueChanged($event)"/>
            <label class="ml-1" paflabel="Oui"></label>
        </div>
    </div>
    <div class="row" *ngIf="visibleAnswerIdx.length>0">
        <div class="col-4 offset-8">
            <div class="card">
                <div class="card-body">
                    <app-supplier-rse-answer-idx *ngFor="let answerIdx of visibleAnswerIdx" [supplierAnswsers]="supplierAnswsers" [answer]="answer" [answerIdx]="answerIdx" [readonly]="readonly"></app-supplier-rse-answer-idx>
                </div>
            </div>
        </div>
    </div>
    
</div>